import { BehaviorSubject, Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { IFsLprResult } from '@lib/vehicle-intelligence/api/interfaces/common/result';

@Injectable({
  providedIn: 'root',
})
export class PlateReviewService {
  private readonly _reviewedPlates$ = new BehaviorSubject<IFsLprResult[]>([]);

  constructor() {}

  /**
   * Get the list of plates marked for review
   */
  public getReviewedPlates(): Observable<IFsLprResult[]> {
    return this._reviewedPlates$.asObservable();
  }

  /**
   * Mark a plate for review
   * @param plate The plate to mark for review
   */
  public markForReview(plate: IFsLprResult): void {
    const currentPlates = this._reviewedPlates$.getValue();
    if (!currentPlates.some((p) => p.id === plate.id)) {
      this._reviewedPlates$.next([...currentPlates, plate]);
    }
  }

  /**
   * Remove a plate from review
   * @param plateId The ID of the plate to remove from review
   */
  public removeFromReview(plateId: string): void {
    const currentPlates = this._reviewedPlates$.getValue();
    this._reviewedPlates$.next(currentPlates.filter((p) => p.id !== plateId));
  }

  /**
   * Check if a plate is marked for review
   * @param plateId The ID of the plate to check
   */
  public isMarkedForReview(plateId: string): boolean {
    return this._reviewedPlates$.getValue().some((p) => p.id === plateId);
  }

  /**
   * Clear all plates marked for review
   */
  public clearReviewedPlates(): void {
    this._reviewedPlates$.next([]);
  }
}
